// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-tab-image-gallery {
  display: block;
  margin: var(--wm-feature-details-margin);
}
wm-tab-image-gallery .webmapp-pageroute-tabdescription-description {
  padding: 15px;
  margin-bottom: 10px;
}
wm-tab-image-gallery .webmapp-pageroute-tabdescription-title {
  font-weight: var(--wm-feature-details-title-font-weight);
  font-size: var(--wm-feature-details-title-font-size);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
}
wm-tab-image-gallery .webmapp-pageroute-tabdescription-photoslider {
  padding: 20px 0;
  overflow: visible;
}
wm-tab-image-gallery .webmapp-pageroute-tabdescription-photoslider .webmapp-pageroute-tabdescription-photo {
  height: 150px;
  width: 250px;
}
wm-tab-image-gallery .webmapp-pageroute-tabdescription-photoslider .webmapp-pageroute-tabdescription-photo::part(image) {
  border-radius: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/tab-image-gallery/tab-image-gallery.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wCAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;AAEJ;AACE;EACE,wDAAA;EACA,oDAAA;EACA,4CAAA;EACA,wDAAA;AACJ;AAEE;EACE,eAAA;EACA,iBAAA;AAAJ;AAEI;EACE,aAAA;EACA,YAAA;AAAN;AACM;EACE,mBAAA;AACR","sourcesContent":["wm-tab-image-gallery{\n  display: block;\n  margin: var(--wm-feature-details-margin);\n  .webmapp-pageroute-tabdescription-description {\n    padding: 15px;\n    margin-bottom: 10px;\n  }\n\n  .webmapp-pageroute-tabdescription-title {\n    font-weight: var(--wm-feature-details-title-font-weight);\n    font-size: var(--wm-feature-details-title-font-size);\n    color: var(--wm-feature-details-title-color);\n    font-family: var(--wm-feature-details-title-font-family);\n  }\n\n  .webmapp-pageroute-tabdescription-photoslider {\n    padding: 20px 0;\n    overflow: visible;\n\n    .webmapp-pageroute-tabdescription-photo {\n      height: 150px;\n      width: 250px;\n      &::part(image) {\n        border-radius: 15px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
